import React from 'react';
import classNames from 'classnames';

export default function NetworkBanner(props) {
  const { network, children } = props;

  if (children) {
    return (
      <div className={classNames(
        'bg-white flex items-center text-cs-gray-700 py-3 px-4',
        '-m-px border border-cs-gray-200',
        'mx-6 mt-4 rounded-cs-10 shadow-cs-flat'
      )}>
        <div className="flex space-x-4 text-left">
            <div className={classNames(
              'flex items-center h-14 w-14 overflow-hidden',
              // 'shadow-cs-flat -m-0.5 border-2 rounded-2xl',
              'shadow-cs-flat -m-px border rounded-cs-10',
              'border-cs-gray-200 bg-white'
            )}>
              <img className="h-11 w-11 object-contain m-auto" src={network.data.logo} alt="logo" />
            </div>
            <span className="flex-1 flex flex-col min-w-0">
              <span className="text-cs-gray-900 text-base font-semibold">
                Announcement from {network.data.name}
              </span>
              <span className={classNames(
                'text-cs-gray-500 text-sm leading-5',
                'prose-p:text-cs-gray-500 prose-p:text-sm prose-p:leading-5',
                'prose-a:text-cs-blue-500 prose-a:hover:text-cs-blue-400 prose-a:text-sm prose-a:leading-5',
                // 'prose-p:text-cs-gray-400 prose-p:text-base prose-p:leading-6',
                // 'prose-a:text-cs-blue-500 prose-a:hover:text-cs-blue-400 prose-a:text-base prose-a:leading-6',
              )}>
                {children}
              </span>
            </span>
          </div>
      </div>
    );
  }

  return null;
};
